import React, {useRef} from "react"
import {useOnClickOutside, useToggle} from "usehooks-ts"
import {useAppDispatch, useAppSelector} from "../../../hooks/redux"
import {USER_ROLE_ADMIN, USER_ROLE_MANAGER} from "../../../utils/constants/userRoles"
import {NavLink} from "react-router-dom"
import {logout} from "../../../store/actions/authActions"
import classes from "./MobileMenu.module.scss"

function MobileMenu() {

  const dispatch = useAppDispatch()
  const [menuOpened, setMenuOpened] = useToggle(false)
  const menuPanelRef = useRef(null)
  const {role_id} = useAppSelector(state => state.auth.user)
  const {isAuthenticated} = useAppSelector(state => state.auth)
  const isExtendedMenu = role_id === USER_ROLE_ADMIN || role_id === USER_ROLE_MANAGER

  const links = isExtendedMenu ? [
    {
      id: 1,
      name: 'Заявки',
      pathname: '/order/',
      icon: 'clipboard'
    },
    {
      id: 2,
      name: 'Сотрудники',
      pathname: '/employee/',
      icon: 'users'
    },
    {
      id: 3,
      name: 'Справочник',
      pathname: '/handbook/',
      icon: 'book'
    },
    {
      id: 4,
      name: 'Настройки профиля',
      pathname: '/profile/',
      icon: 'profile'
    }
  ] : [
    {
      id: 1,
      name: 'Заявки',
      pathname: '/order/',
      icon: 'clipboard'
    },
    {
      id: 2,
      name: 'Настройки профиля',
      pathname: '/profile/',
      icon: 'profile'
    }
  ]

  const templateMenuList = links.map(link => {
    return (
      <div
        className={classes.nav_item}
        key={link.id}
      >
        <NavLink
          to={link.pathname}
          className={classes.nav_link}
        >
          <i className={[classes.nav_icon, classes[`nav_icon_${link.icon}`]].join(" ")}></i>
          <span className={classes.nav_text}>{link.name}</span>
        </NavLink>
      </div>
    )
  })

  const handleClickOutside = () => {
    setMenuOpened()
  }

  useOnClickOutside(menuPanelRef, handleClickOutside)

  const logoutHandler = async () => {
    await dispatch(logout())
  }

  return (
    <>
      <div
        className={classes.burger}
        onClick={setMenuOpened}
      >
        <span></span>
      </div>
      {menuOpened &&
        <div className={classes.wrap}>
          <div
            className={classes.panel}
            ref={menuPanelRef}
          >
            <div className={classes.header}>
              <div
                className={classes.close}
                onClick={setMenuOpened}
              ></div>
            </div>
            <div
              className={classes.nav}
              onClick={setMenuOpened}
            >

              {templateMenuList}
              {isAuthenticated &&
                <div className={classes.nav_item}>
                  <span
                    className={classes.nav_link}
                    onClick={logoutHandler}
                  >
                    <i className={[classes.nav_icon, classes.nav_icon_power].join(" ")}></i>
                    <span className={classes.nav_text}>Выход</span>
                  </span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default MobileMenu